<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12" sm="10" md="12" xl="10" class="wizard">
        <v-row no-gutters>
          <v-col cols="12">
            <div class="d-flex justify-space-between align-center">
              <h2 class="my-5">
                {{ $t("message.common.fillYourCompanyData") }}
              </h2>
              <div class="d-flex align-center">
                <ui-button
                  outlined
                  transparent
                  color="primary"
                  :href="`mailto:${email}`"
                >
                  {{ $t("message.common.reportProblem") }}
                </ui-button>
                <ChooseLanguage />
              </div>
            </div>
          </v-col>
        </v-row>
        <v-row no-gutters justify="center" class="company-form">
          <v-col>
            <router-view></router-view>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ChooseLanguage from "@/components/AppBar/ChooseLanguage.vue";
import constants from "@/config/constants";

export default {
  name: "Wizard",
  components: {
    ChooseLanguage
  },
  data() {
    return {
      email: constants.centerAiEmail
    };
  },
  computed: {
    steps() {
      return [
        { name: this.$t("message.common.yourCompany") },
        { name: this.$t("message.common.businessAddresses") },
        { name: this.$t("message.wizard.companyInWeb.name") }
      ];
    }
  }
};
</script>

<style lang="scss" scoped>
.wizard__title {
  @include font-size(25px);
  line-height: 30px;
  font-weight: $font-weight-semi-bold;
  font-family: $font-family-base;
}

.company-form {
  margin-top: $spacing * 2;
  border: 1px solid $gray-600;
  position: relative;
  min-height: 700px;
}
</style>
